import ATMCountPrintComponent from './atm_count_print.component';

let ATMCountPrintModule = angular.module('atmCountPrint', [
	])
	.config(($stateProvider, $urlRouterProvider) => {
		"ngInject";

		$urlRouterProvider.otherwise('/atm-count');

		$stateProvider
			.state('atmCountPrint', {
				url: '/atm-count-print',
				component: 'atmCountPrint',
				data: {
					requireLogin: true,
					requireACL: 'atm_count.all'	
				},
			});
	})

	.component('atmCountPrint', ATMCountPrintComponent)

	.name;

export default ATMCountPrintModule;


// WEBPACK FOOTER //
// ./client/app/components/atm_count/print/index.js